module.exports = __webpack_public_path__ + "static/img/13.796c7e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresas/13.png
// module id = s0ZH
// module chunks = 0